import { INDICATORS } from "../../configs/constants";
import MIN_MAX_VALUES from "../../data/minMaxValues.json";
import { Blockgroup } from "../../types";

const getScoreGoal = (
  canopyGap: number,
  canopyGapMin: number,
  canopyGapMax: number,
  equityIndex: number
) => {
  console.log(canopyGap);
  console.log(canopyGapMin);
  console.log(canopyGapMax);
  console.log(equityIndex);
  const gapScore = (canopyGap - canopyGapMin) / (canopyGapMax - canopyGapMin);
  const score = (1 - gapScore * equityIndex) * 100;
  return Math.min(score, 100); // avoid rounding errors
};

export const getScore = (blockgroup: Blockgroup) => {
  console.log(blockgroup);
  if (!Object.keys(blockgroup).includes("properties")) {
    return blockgroup.tes;
  }
  const equityIndex = blockgroup.properties.equity_ind;
  const canopy = blockgroup[INDICATORS.TREE_CANOPY_PERCENT.field];
  const totalAcres = blockgroup.TotalAcres;
  const canopyGoal = blockgroup[INDICATORS.TREE_CANOPY_GOAL.field];
  const canopyGapMin =
    MIN_MAX_VALUES[blockgroup.properties.NAME].min * totalAcres;
  const canopyGapMax =
    MIN_MAX_VALUES[blockgroup.properties.NAME].max * totalAcres;
  let currentCanopy = canopy * totalAcres;
  let canopyGap =
    canopyGoal * totalAcres - (currentCanopy + (blockgroup.acresAdded || 0));
  canopyGap = Math.max(canopyGap, 0);
  return getScoreGoal(canopyGap, canopyGapMin, canopyGapMax, equityIndex);
};
